import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';

import { ROLES, SUPERVISOR } from 'utils/roles';

import Employees from 'api/resources/employees';
import { processErrorByAlert } from 'utils/getErrors';
import { Deserializer } from 'jsonapi-serializer';

import Checkbox from 'components/Checkbox';
import ButtonLoader from 'components/Loader/ButtonLoader';

import Button from 'styled/Buttons/PrimaryButton';
import SectionHeader from 'styled/Page/SectionHeader';
import Input from 'styled/Input';
import Label from 'styled/Label';
import RightColumnBody from 'styled/Page/RightColumnBody';

import Checkboxes from './Checkboxes';

export class CreateEmployee extends React.PureComponent {
  state = {
    email: '',
    editor: false,
    biller: false,
    journalist: false,
    moderator: false,
    corrector: false,
  };

  get roles() {
    return ROLES.reduce((acc, role) => (this.state[role.value]
      ? acc.concat(role.value)
      : acc
    ), []);
  }

  handleChange = (e) => {
    this.setState({ email: e.target.value });
  }

  handleCheckboxChange = (e) => {
    this.setState({ [e.target.id]: e.target.checked });
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    try {
      // TODO: использовать Serializer
      const response = await Employees.create({
        body: {
          data: {
            type: 'employee',
            attributes: {
              email: this.state.email,
              roles: this.roles,
            },
          },
        },
      });
      const employee = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      Alert.success('Сотрудник добавлен');

      this.props.onCreate(employee);
      this.setState({
        loading: false,
        email: '',
        editor: false,
        biller: false,
        journalist: false,
        moderator: false,
        corrector: false,
      });
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <React.Fragment>
        <SectionHeader>Добавить сотрудника</SectionHeader>

        <RightColumnBody as="form" onSubmit={this.handleSubmit}>
          <Label htmlFor="email">Электронный адрес</Label>

          <Input
            id="email"
            type="email"
            onChange={this.handleChange}
            value={this.state.email}
            required
          />

          <Label htmlFor="roles" style={{ margin: '24px 0 15px' }}>Роль</Label>

          <Checkboxes id="roles">
            {ROLES.map((role) => {
              if (role.value === SUPERVISOR) return null;

              return (
                <Checkbox
                  key={role.value}
                  id={role.value}
                  onChange={this.handleCheckboxChange}
                  checked={this.state[role.value]}
                  toggle
                  style={{ width: '160px' }}
                >
                  {role.label}
                </Checkbox>
              );
            })}
          </Checkboxes>

          <Button
            type="submit"
            style={{ width: '125px', opacity: 1 }}
            disabled={this.state.loading}
          >
            {this.state.loading ? <ButtonLoader /> : 'Пригласить'}
          </Button>
        </RightColumnBody>
      </React.Fragment>
    );
  }
}

CreateEmployee.propTypes = {
  onCreate: PropTypes.func.isRequired,
};

export default CreateEmployee;
